import React, { useState } from 'react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';

function ProductCard({ product, onClick }) {
  const [currentImage, setCurrentImage] = useState(0);
  const { addToCart, removeFromCart, updateQuantity, cartItems } = useCart();
  const navigate = useNavigate();

  const cartItem = cartItems.find((item) => item.id === product.id);
  const quantity = cartItem ? cartItem.quantity : 0;

  const prevImage = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setCurrentImage((prev) => (prev === 0 ? product.images.length - 1 : prev - 1));
  };

  const nextImage = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setCurrentImage((prev) => (prev === product.images.length - 1 ? 0 : prev + 1));
  };

  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product);
  };

  const handleIncrease = (e) => {
    e.stopPropagation();
    updateQuantity(product.id, quantity + 1);
  };

  const handleDecrease = (e) => {
    e.stopPropagation();
    if (quantity === 1) {
      removeFromCart(product.id);
    } else {
      updateQuantity(product.id, quantity - 1);
    }
  };

  const handleBuyNow = (e) => {
    e.stopPropagation();
    if (quantity === 0) addToCart(product);
    navigate('/cart');
  };

  return (
    <div className="product-card" onClick={onClick}>
      <div className="product-card__image-wrapper">
        <img
          src={product.images[currentImage]}
          alt={`${product.name} ${currentImage + 1}`}
          className="product-card__image"
          draggable="false"
          loading="lazy"
        />
        {product.images.length > 1 && (
          <>
            <button
              className="product-card__arrow product-card__arrow--left"
              onClick={prevImage}
              onMouseDown={(e) => e.preventDefault()}
              onTouchStart={(e) => e.stopPropagation()}
            >&#8249;</button>
            <button
              className="product-card__arrow product-card__arrow--right"
              onClick={nextImage}
              onMouseDown={(e) => e.preventDefault()}
              onTouchStart={(e) => e.stopPropagation()}
            >&#8250;</button>
            <div className="product-card__dots">
              {product.images.map((_, i) => (
                <span
                  key={i}
                  className={`product-card__dot ${i === currentImage ? 'active' : ''}`}
                  onClick={(e) => { e.stopPropagation(); setCurrentImage(i); }}
                />
              ))}
            </div>
          </>
        )}
      </div>
      <div className="product-card__info">
        <h3 className="product-card__name">{product.name}</h3>
        <p className="product-card__price">₹{product.price}</p>
        <p className="product-card__desc">{product.shortDescription}</p>
        <div className="product-card__actions">
          {quantity === 0 ? (
            <button className="product-card__add-btn" onClick={handleAddToCart}>
              Add to Cart
            </button>
          ) : (
            <div className="product-card__qty-control" onClick={(e) => e.stopPropagation()}>
              <button
                className="product-card__qty-btn"
                onClick={handleDecrease}
                onMouseDown={(e) => e.preventDefault()}
              >−</button>
              <span>{quantity}</span>
              <button
                className="product-card__qty-btn"
                onClick={handleIncrease}
                onMouseDown={(e) => e.preventDefault()}
              >+</button>
            </div>
          )}
          <button className="product-card__buy-btn" onClick={handleBuyNow}>
            Buy Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;